/**
 * Purpose: Filter and normalize options for SearchableSelect.
 * Inputs: options (strings or { value, label }), query string.
 * Outputs: Normalized option arrays and filtered subsets.
 */

export function normalizeSelectOptions(options) {
  if (!Array.isArray(options)) return [];
  return options.map((opt) => {
    if (opt && typeof opt === 'object' && opt.value != null) {
      return {
        value: String(opt.value),
        label: String(opt.label ?? opt.value),
      };
    }
    const s = String(opt ?? '');
    return { value: s, label: s };
  });
}

export function filterOptionsByQuery(options, query) {
  const normalized = normalizeSelectOptions(options);
  const q = (query || '').toLowerCase().trim();
  if (!q) return normalized;
  return normalized.filter((opt) => opt.label.toLowerCase().includes(q));
}

export function getSelectedOptionLabel(options, value) {
  const normalized = normalizeSelectOptions(options);
  const match = normalized.find((opt) => opt.value === String(value ?? ''));
  return match ? match.label : '';
}

export function societyListToSelectOptions(societies, { showCity = true } = {}) {
  if (!Array.isArray(societies)) return [];
  return societies.map((s) => ({
    value: String(s.id),
    label: showCity && s.city ? `${s.name} - ${s.city}` : s.name || '',
  }));
}
